/** All available not filled analytical features */
export enum ContractAnalyticalFeatureEnum {
  /** With not filled directions */
  DIRECTION = 'DIRECTION',
  /** With not filled units */
  UNIT = 'UNIT',
  /** With not filled filials */
  FILIAL = 'FILIAL',
  /** With not filled cost centers */
  COST_CENTER = 'COST_CENTER',
  /** With not filled deals */
  DEAL = 'DEAL',
}
